let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '优惠券名称',
        props: 'couponName',
        minWidth: 220,
    },
    {
        label: '优惠券编号',
        props: 'couponNo',
        minWidth: 200,
    },
    {
        label: '优惠券兑换流水号',
        props: 'couponExchangeNo',
        minWidth: 200,
    },
    {
        label: '优惠券类型',
        props: 'couponTypeName',
        minWidth: 180,
    },
    {
        label: '卡券归属',
        props: 'couponBelongName',
        minWidth: 150,
    },
    {
        label: '发放平台',
        props: 'provideChannelName',
        minWidth: 180,
    },
    {
        label: '发放日',
        props: 'exchangeDay',
        minWidth: 200,
    },
    {
        label: '发放月',
        props: 'exchangeMonth',
        minWidth: 200,
    },
    {
        label: '发放年',
        props: 'exchangeYear',
        minWidth: 200,
    },
     
     
    {
        label: '券值/元',
        props: 'prizeAmount',
        minWidth: 130,
    },
     
    {
        label: '积分兑换数',
        props: 'exchangePoints',
        minWidth: 130,
    },
    {
        label: '兑换成功时间',
        props: 'exchangeSuccessWhen',
        minWidth: 130,
    },
    {
        label: '兑换结束时间',
        props: 'exchangeWhen',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
    {
        label: '创建人',
        props: 'createdByName',
        minWidth: 200,
    },
    {
        label: '创建时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '更新人',
        props: 'lastModifiedByName',
        minWidth: 200,
    },
    {
        label: '更新时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
];
pageConfig.logListColumns = [
    {
        label: '更新人',
        props: 'couponName',
        minWidth: 220,
    },
    {
        label: '更新时间',
        props: 'couponNo',
        minWidth: 200,
    },
    {
        label: '更新操作',
        props: 'couponExchangeNo',
        minWidth: 200,
    },
    {
        label: '更新操作',
        props: 'couponTypeName',
        minWidth: 180,
    },
   
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理'
    },
    {
        type: 'title',
        name: '优惠券发放列表'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}


// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理',
    },
    {
        type: 'router',
        name: '优惠券配置',
        router: 'activityOrderList'
    },
    {
        type: 'title',
        name: '优惠券详情'
    }
];
// 详情的面包屑
pageConfig.logBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理',
    },
    {
        type: 'router',
        name: '优惠券配置',
    },
    {
        type: 'title',
        name: '更新记录'
    }
];


pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
};



export default pageConfig;
